import { common } from '@kurtosys/ksys-app-template';
import { IBaseEventDetail } from '@kurtosys/types/eventBus/index.js';

interface EventDetail extends IBaseEventDetail {
	identifier: string;
}
export type PagingAction = 'First' | 'Previous' | 'Next' | 'Last' | 'PageNumber' | 'PageSize';
export interface UpdatePaginationDetail extends EventDetail {
	pagingData?: PagingData;
}
export interface PaginationChangeDetail extends EventDetail {
	action: PagingAction; // indicator of what button was pressed
	newPagingData: PagingData;
	oldPagingData?: PagingData;
}
export interface PagingData {
	pageSize: number; // linked to limit on the API request body
	pageIndex?: number;
	recordIndex: number; // linked to start on the API request body
	totalRecords: number; // linked to start on the API response body
}
type EventCallback<T extends EventDetail> = (detail: T) => void;

if (customElements.get('ksys-event-bus') === undefined) {
	class KsysEventBus extends HTMLElement {
		constructor() {
			super();
			this.attachShadow({ mode: 'open' });
		}
	}
	customElements.define('ksys-event-bus', KsysEventBus);
}

export class EventBus {
	static helper: common.helpers.EventBusHelper = new common.helpers.EventBusHelper('');

	static triggerUpdatePagination(eventDetail: UpdatePaginationDetail) {
		EventBus.helper.trigger('ksys-update-pagination', {
			detail: eventDetail,
		});
	}

	static registerUpdatePagination(appKey: string, callback: EventCallback<UpdatePaginationDetail>) {
		EventBus.registerEvent('ksys-update-pagination', appKey, callback);
	}

	static triggerPaginationOnChange(eventDetail: PaginationChangeDetail) {
		EventBus.helper.trigger('ksys-pagination-on-change', {
			detail: eventDetail,
		});
	}

	static registerPaginationOnChange(appKey: string, callback: EventCallback<PaginationChangeDetail>) {
		EventBus.registerEvent('ksys-pagination-on-change', appKey, callback);
	}

	private static registerEvent<T extends EventDetail>(
		eventKey: string,
		appIdentifier: string,
		callback: EventCallback<T>,
	) {
		EventBus.helper.register(eventKey, {
			handleEvent: async (customEvent: CustomEvent<T>) => {
				const { identifier = '' } = customEvent.detail;
				if (appIdentifier === identifier) {
					callback(customEvent.detail);
				}
			},
		});
	}
}
